"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtPaymentState = void 0;
/**
 * @deprecated Use BtPaymentState2 instead.
 */
var BtPaymentState;
(function (BtPaymentState) {
    /**
     * Ready to receive payments
     */
    BtPaymentState["CREATED"] = "created";
    /**
     * Partially paid order will just be displayed as `created`.
     */
    BtPaymentState["PARTIALLY_PAID"] = "partiallyPaid";
    /**
     * Order is paid
     */
    BtPaymentState["PAID"] = "paid";
    /**
     * Order is refunded.
     */
    BtPaymentState["REFUNDED"] = "refunded";
    /**
     * Onchain refunds can't be done automatically. `refundAvailable` is displayed in this case.
     */
    BtPaymentState["REFUND_AVAILABLE"] = "refundAvailable"; // Onchain refund available
})(BtPaymentState = exports.BtPaymentState || (exports.BtPaymentState = {}));
//# sourceMappingURL=BtPaymentState.js.map